var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('buttons-group',{attrs:{"items":_vm.items,"indexStep":_vm.index,"disabledAll":false},on:{"click":_vm.getIndex}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }